import React from "react";
import { Quote, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function UzmanArabuluculukHizmetleri() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section id="uzman-arabuluculuk-hizmetleri" ref={ref} className={cn("dark bg-[#0b1221] text-foreground py-24 px-6 md:py-32 relative overflow-hidden transition-opacity duration-1000", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full max-w-4xl pointer-events-none opacity-5">
        <Quote className="w-full h-full text-[#c5a059] rotate-180 scale-150" />
      </div>

      <div className="relative z-10 max-w-[800px] mx-auto flex flex-col items-center text-center space-y-10">
        <div className="space-y-6">
          <Quote className="w-12 h-12 text-[#c5a059]/40 mx-auto mb-6" />
          
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif leading-tight tracking-tight text-[#b4b4b4]">
            "Ticari uyuşmazlıklarda en etkili çözüm, çatışmayı yönetmek değil, <span className="text-primary italic">uzlaşıyla</span> sonlandırmaktır."
          </h2>
          
          <p className="text-lg md:text-xl text-muted-foreground font-sans font-light leading-relaxed max-w-2xl mx-auto">
            Arabuluculuk; iş dünyasında zaman, maliyet ve itibar kaybını önleyen, tarafların iradesine dayalı, hızlı ve gizli bir çözüm yoludur.
          </p>
        </div>

        <div className="pt-4">
          <Button asChild variant="ghost" size="lg" className="text-lg font-medium hover:bg-primary/10 hover:text-primary transition-all duration-300 group">
            <Link to="https://celikhukuk.net/arabuluculuk/">
              Daha Fazla Bilgi
              <ArrowRight className="ml-2 w-5 h-5 transition-transform group-hover:translate-x-1" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}